"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var header_html_1 = __importDefault(require("./header.html"));
var environment_1 = require("@shared/types/environment");
(function (module) {
    function HeaderController($routeParams, env, triggerOverrides, OVERRIDE_EVENTS) {
        var activeSurveyId = $routeParams.surveyId;
        var activeProjectId = $routeParams.projectId || env.get('activeProjectId') || activeSurveyId;
        var resourceType = _.get($routeParams, 'resourceTypeForNavContext', 'SurveyProject');
        this.headerOptions = {
            activeSuperTabId: $routeParams.projectId ? 'ProjectsSection' : 'SurveysSection',
            activeSectionTabId: 'PaginatedReportsSection',
            activeSubTabId: 'PaginatedReportsSection',
            activeProjectId: activeProjectId,
            activeSurveyId: activeSurveyId
        };
        // global-wrapper-fallback v2 params
        // migration doc: https://docs.google.com/document/d/1H1eYidjxh95Z9s8uDrPB--eM7xIZnBk6x4_OQ0z3dOI/edit#
        this.user = env.get('user') || {};
        this.userLanguage = env.get('userLanguage') || this.user.language;
        this.pageId = 'PaginatedReports';
        this.context = {
            resourceId: activeProjectId,
            resourceType: resourceType,
            subresourceId: activeSurveyId,
            subresourceType: 'Survey',
            contextType: 'Project'
        };
        var resourceId = $routeParams.resourceId;
        var resourceDetails = env.get(environment_1.ENV_VARS.RESOURCE_DETAILS);
        if (resourceDetails) {
            var v2ResourceType = resourceDetails.resourceType, projectType = resourceDetails.projectType;
            if (resourceId && v2ResourceType && projectType) {
                this.headerOptions.activeProjectId = resourceId;
                this.headerOptions.subprojectType = v2ResourceType;
                this.headerOptions.projectType = projectType;
                this.context.resourceType = projectType;
                this.context.subresourceType = v2ResourceType;
                this.context.resourceId = resourceId;
            }
        }
        else {
            var projectType = env.get(environment_1.ENV_VARS.PROJECT_TYPE);
            if (projectType) {
                this.headerOptions.projectType = projectType;
                this.context.resourceType = projectType;
            }
        }
        var self = this;
        triggerOverrides({
            event: OVERRIDE_EVENTS.HEADER_OPTIONS,
            data: {
                headerOptions: this.headerOptions,
                context: this.context,
                pageId: this.pageId
            }
        }).then(function (options) {
            self.headerOptions = options.headerOptions;
            self.context = options.context;
            self.pageId = options.pageId;
        });
        this.useCustomHeader = !!triggerOverrides({
            event: OVERRIDE_EVENTS.CUSTOM_HEADER_TEMPLATE,
            sync: true
        });
    }
    HeaderController.$inject = [
        '$routeParams',
        'rsEnvironment',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS'
    ];
    HeaderController.prototype = {};
    module.component('prHeader', {
        controller: HeaderController,
        controllerAs: 'hdrCtrl',
        templateUrl: header_html_1.default
    });
    module.directive('prCustomHeader', [
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        function (triggerOverrides, OVERRIDE_EVENTS) {
            return {
                template: function () {
                    return triggerOverrides({
                        event: OVERRIDE_EVENTS.CUSTOM_HEADER_TEMPLATE,
                        sync: true
                    });
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
